import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/be791082-92c6-4516-a44e-e74d1ddbe03d.png"
                alt="Central Pool and Spa"
                className="h-12 w-auto"
              />
            </Link>

            <div className="flex items-center gap-8">
              <Link
                to="/"
                className={`text-base font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-tropical-teal'
                    : isScrolled
                    ? 'text-charcoal hover:text-tropical-teal'
                    : 'text-white hover:text-soft-aqua'
                }`}
              >
                Home
              </Link>
              <Link
                to="/services"
                className={`text-base font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/services'
                    ? 'text-tropical-teal'
                    : isScrolled
                    ? 'text-charcoal hover:text-tropical-teal'
                    : 'text-white hover:text-soft-aqua'
                }`}
              >
                Services
              </Link>
              <a
                href="tel:+17862738796"
                className="bg-tropical-teal text-white px-6 py-2.5 rounded-full font-semibold hover:bg-soft-aqua transition-all hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                Call Now
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Sticky Call Button */}
      <a
        href="tel:+17862738796"
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-coral-pink text-white py-4 text-center font-bold text-lg shadow-lg flex items-center justify-center gap-2 cursor-pointer"
        style={{ boxShadow: '0 -4px 20px rgba(77, 208, 225, 0.3)' }}
      >
        <i className="ri-phone-fill text-xl"></i>
        Call Now
      </a>
    </>
  );
}